module.exports = __webpack_public_path__ + "static/media/remainder.fb9d1ee4.svg";